import React, { useEffect } from 'react';
import { BooleanInput, useTranslate } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { MaskedDateTimeInput } from '../event-utils/MaskedDateTimeInput';

/**
 * Event refund settings — shown at the top of Products / Stocks tab.
 */
export const EventRefundSettings = () => {
  const translate = useTranslate();
  const { setValue } = useFormContext();
  const refundEnabled = useWatch({ name: 'refundEnabled' });
  const startdate = useWatch({ name: 'startdate' });

  useEffect(() => {
    if (refundEnabled === false) {
      setValue('refundDeadlineAt', null, { shouldDirty: true });
    }
  }, [refundEnabled, setValue]);

  return (
    <React.Fragment>
      <h3 style={{ marginTop: 0 }}>{translate('form.refund_settings', 'İade Ayarları')}</h3>
      <BooleanInput
        source="refundEnabled"
        label={translate('form.refund_enabled', 'İade kabul edilsin mi?')}
        helperText={translate(
          'form.refund_enabled_hint',
          'Kapalıysa kullanıcılar bu etkinlik için web üzerinden iade yapamaz.',
        )}
        defaultValue={true}
      />
      {refundEnabled !== false && (
        <MaskedDateTimeInput
          source="refundDeadlineAt"
          label={translate('form.refund_deadline', 'İade son kabul tarih / saat')}
          disabled={!startdate}
          validate={[
            (value) => {
              if (!value || !startdate) return undefined;
              return new Date(value).getTime() > new Date(startdate).getTime()
                ? translate(
                    'form.refund_deadline_error',
                    'İade son tarihi etkinlik başlangıcından sonra olamaz.',
                  )
                : undefined;
            },
          ]}
          helperText={
            startdate
              ? translate(
                  'form.refund_deadline_hint',
                  'Kullanıcılar bu tarih ve saate kadar iade yapabilir. Boş bırakılırsa süre sınırı yoktur.',
                )
              : translate(
                  'form.refund_deadline_startdate_hint',
                  'Önce event tarihini girin. Sonra iade için son kabul tarih/saat seçebilirsiniz.',
                )
          }
        />
      )}
    </React.Fragment>
  );
};
